// Low-profit quote warnings: the API compares each quote's profit per person (total minus the
// supplier rates, final rates once entered) with the margin set for its location and event type.
// See docs/reference/LOW_PROFIT_QUOTES.md.

// Checks keyed by quote id ({} when there are no quotes or the request fails).
export async function fetchProfitChecks(axios, quotes) {
    const quote_ids = (quotes || []).map((quote) => quote.id).filter(Boolean)
    if (!quote_ids.length) return {}
    const response = await axios.post('admin/quotes/profit_checks', { quote_ids })
    const result = response && response.data
    return result && result.response ? (result.data || {}) : {}
}
